module.exports = __webpack_public_path__ + "images/virtual-labs.e80b9732.webp";